import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const AriaFloatingButton = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  if (pathname.startsWith('/aria')) return null;
  return (
    <Link to="/aria?tab=conversa" aria-label={t('aria.fab')} title={t('aria.fab')} data-testid="aria-fab"
      className="fixed right-4 bottom-24 lg:bottom-6 z-40 h-14 w-14 rounded-full shadow-lg shadow-violet-500/30 ring-2 ring-violet-400/60 overflow-hidden transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-500">
      <img src="/aria/hibrido.png" alt="" className="h-full w-full object-cover" />
    </Link>
  );
};
